import React from "react";
import WizardProductDropDown from "./WizardProductDropDown";

const WizardProductManager = ({ data, setData }) => {
    const setBundleProduct = ({ ingredientId, product }) => {
        data.bundles.forEach((bundle) => {
            if (bundle.ingredient.id === ingredientId) {
                bundle.product = product;
            }
        });
        setData({ ...data, bundles: data.bundles });
    };

    return (
        <div>
            {data?.bundles?.length > 0 ? (
                data.bundles.map((bundle) => {
                    return (
                        <WizardProductDropDown
                            ingredient={bundle.ingredient}
                            setProduct={setBundleProduct}
                        />
                    );
                })
            ) : (
                <span style={{ color: "grey" }}>
                    No ingredients have been added yet.
                </span>
            )}
        </div>
    );
};

export default WizardProductManager;
